import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'formik-material-ui';
import { FormControlLabel, makeStyles, FormHelperText } from '@material-ui/core';
import sanitizer from '../../../services/sanitize-service';

const useInputStyles = makeStyles((theme) => ({
  wrapper: {
    marginBottom: theme.spacing(5),
  },
  // label: {
  //   marginBottom: 10,
  // },
  helperText: {
    marginLeft: 31,
  },
  // checkboxField: {
  //   alignItems: 'flex-start',
  // },
  checkbox: {
    paddingTop: 0,
  },
}));

const InputCheckbox = ({ hint, label, required, ...props }) => {
  const {
    field: { name, value },
    form: { errors, touched },
  } = props;

  const classes = useInputStyles();

  const isErrorDisplay = () => {
    if (touched[name]) {
      return !!errors[name];
    }
    return false;
  };

  const labelToDisplay = (
    <span dangerouslySetInnerHTML={{ __html: sanitizer(`${label}${required ? '*' : ''}`) }} />
  );

  return (
    <div className={classes.wrapper}>
      <FormControlLabel
        control={
          <Checkbox
            className={classes.checkbox}
            type="checkbox"
            checked={value}
            {...props}
            required={required}
            color="primary"
          />
        }
        label={labelToDisplay}
        classes={{ root: classes.checkboxField, label: classes.label }}
      />
      <FormHelperText className={classes.helperText} variant="filled" required margin="dense">
        {hint}
      </FormHelperText>

      {isErrorDisplay() && (
        <FormHelperText
          className={classes.helperText}
          variant="filled"
          required
          error
          margin="dense"
        >
          {errors[name]}
        </FormHelperText>
      )}
    </div>
  );
};

InputCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  hint: PropTypes.string,
};

InputCheckbox.defaultProps = {
  hint: '',
};

export default InputCheckbox;
